"use client";

import { useEffect } from "react";

import { useLocationStore } from "@/store/location.store";
import { RecommendedData, RegionData } from "@/types/store/location.types";

interface Props {
  recommendedVal: RecommendedData[];
  regionVal: RegionData[];
}

export const LocationState = ({ recommendedVal, regionVal }: Props) => {
  const { setRecommended, setRegionValue } = useLocationStore();

  useEffect(() => {
    setRecommended(recommendedVal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recommendedVal]);

  useEffect(() => {
    setRegionValue(regionVal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [regionVal]);

  return null;
};
